
import { defineComponent, Ref, ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import { List, PullRefresh } from 'vant'
import refreshPageSetup from '@/compositions/refreshPage'
import { GetPurchaseHistories } from '@/apis/standby'
import getRoute from '@/compositions/route'
import { PurchaseItem } from '@/types/standby'

export default defineComponent({
  name: 'Standby-Purchases',
  components: {
    AppHeader,
    VanList: List,
    VanPullRefresh: PullRefresh,
  },
  setup() {
    let {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      generateLoad,
      generateRefresh,
      errorDealFunc,
    } = refreshPageSetup()
    const { params } = getRoute()
    const items: Ref<PurchaseItem[]> = ref([])
    const getItems = async (): Promise<void> => {
      const ts: number = _ts
      try {
        let list: PurchaseItem[] = await GetPurchaseHistories({
          sn: (params.value?.sn as string) || '',
        })
        list = list || []
        if (ts !== _ts) return
        if (refreshing.value) {
          items.value = []
          refreshing.value = false
        }
        list.forEach((it: PurchaseItem) => {
          switch (it.business_type) {
            case 1:
              it.business_name = '设备使用费'
              break
            default:
              it.business_name = '未知费用类型'
          }
        })
        items.value = _query.page === 1 ? list : items.value.concat(...list)
        loading.value = false
        finished.value = list.length < _query.per_page
      } catch (err: unknown) {
        if (ts !== _ts) return
        errorDealFunc(err as { message: string })
      }
    }
    const onLoad = generateLoad(getItems)
    const onRefresh = generateRefresh(getItems)
    return {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      items,
      onLoad,
      onRefresh,
      getItems,
    }
  },
  methods: {
    onClickItem(item: PurchaseItem): void {
      this.$router.push({
        name: 'standby-orderdetail',
        params: { sn: item.sn },
        query: { type: item.pay_status },
      })
    },
  },
})
